import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Status } from 'modules/ats/lib/enums'

interface Props {
  onPromote: () => void
  onStopPromoting: () => void
  status?: Status
}

export const Action = ({ onPromote, onStopPromoting, status }: Props) => {
  switch (status) {
    case Status.Live: {
      return (
        <>
          <Button.Router
            to="https://linkedin.com"
            blankTarget
            rel="noopener noreferrer"
            type="secondary"
            iconName="link"
          >
            {i18n.t('ats.job_details.promotion.vonq.open')}
          </Button.Router>
          <Button onClick={onStopPromoting} type="negative">
            {i18n.t('ats.job_details.promotion.vonq.stop_promoting')}
          </Button>
        </>
      )
    }
    case Status.InProgress: {
      return (
        <Button onClick={onStopPromoting} type="negative">
          {i18n.t('ats.job_details.promotion.vonq.stop_promoting')}
        </Button>
      )
    }
    default:
      return (
        <Button onClick={onPromote} type="secondary">
          {i18n.t('ats.job_details.promotion.vonq.promote_button')}
        </Button>
      )
  }
}
